export enum AccessStatusType {
  INSUFFICIENT_RIGHTS = 'insufficient_rights',
  PERMITTED = 'permitted',
  UNKNOWN = 'unknown'
}
